import { Deserializable } from '../protocols/deserializable';
import { MemberRetirementStubHistory } from './member-retirement-stub-history';
import { MemberRetirementTypeIdEnum } from '../enum/shared/member-retirement-type-id';
import { RetirementType } from './retirement-type';

export class MemberRetirementStub implements Deserializable {
  public id!: number;
  public memberId!: number;
  public retirementTypeId!: MemberRetirementTypeIdEnum;
  public retirementType!: RetirementType;
  public effectiveDate!: string;
  public retirementStubHistory: MemberRetirementStubHistory[] = [];

  public onDeserialize(): void {
    if (!!this.retirementType) {
      this.retirementType = window?.injector?.Deserialize?.instanceOf(RetirementType, this.retirementType);
    }
    if (this.retirementStubHistory?.length) {
      this.retirementStubHistory = window?.injector?.Deserialize?.arrayOf(
        MemberRetirementStubHistory,
        this.retirementStubHistory
      );
    }
  }
}
